import { useState } from 'react'
import SelectBundle from '../ui/select-bundle'
import selectStyle from '../const/select'
import SearchSvg from '../assets/img/svg/search'
import strEmpty from '../utils/strEmpty'

const NavBar = ({ searchParams, setSearchParams }) => {
  const filter = searchParams.get('filter')
  const search = searchParams.get('search')
  const [bundle, setBundle] = useState(filter || 'all')
  const optBundle = [
    { value: 'all', label: 'All bundles' },
    { value: 'pause', label: 'On pause' },
    { value: 'started', label: 'Started' },
    { value: 'deleted', label: 'Deleted' },
  ]

  return (
    <div className="nav-bar">
      <SelectBundle
        value={bundle || filter}
        callback={(e) => {
          setBundle(e.value)
          searchParams.set('filter', e.value)
          setSearchParams(searchParams)
        }}
        style={selectStyle}
        opt={optBundle}
        placeholder={'All bundles'}
      />
      <div className="nav-bar-search">
        <input
          placeholder="Search"
          value={search || ''}
          onChange={(e) => {
            if (strEmpty(e.target.value)) {
              searchParams.delete('search')
              setSearchParams(searchParams)
            } else {
              searchParams.set('search', e.target.value)
              setSearchParams(searchParams)
            }
          }}
        />
        <SearchSvg />
      </div>
    </div>
  )
}

export default NavBar
